'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _interopRequireWildcard = require('babel-runtime/helpers/interop-require-wildcard')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _componentsComponent = require('../../components/Component');

var _componentsComponent2 = _interopRequireDefault(_componentsComponent);

var _dbinfo = require('../../dbinfo');

var _dbinfo2 = _interopRequireDefault(_dbinfo);

var _constants = require('../../constants');

var c = _interopRequireWildcard(_constants);

var _componentsToolbar = require('../../components/Toolbar');

var _componentsToolbar2 = _interopRequireDefault(_componentsToolbar);

var _reactBootstrap = require('react-bootstrap');

var _reactisForms = require('reactis-forms');

var _reactisInputs = require('reactis-inputs');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactisModal = require('reactis-modal');

var _reactisLoader = require('reactis-loader');

var _componentsFormDB = require('../../components/FormDB');

var _componentsFormDB2 = _interopRequireDefault(_componentsFormDB);

var _reduxModulesProfile = require('../../redux/modules/profile');

var actions = _interopRequireWildcard(_reduxModulesProfile);

var _reactDocumentTitle = require('react-document-title');

var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);

var _Chart = require('./Chart');

var _Chart2 = _interopRequireDefault(_Chart);

var _components = {
	_$Page: {
		displayName: 'Page'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var Page = (function (_Component) {
	_inherits(Page, _Component);

	function Page(props) {
		_classCallCheck(this, _Page);

		_Component.call(this, props);
		this.schema = {
			metric: {
				'class': _reactisInputs.Select,
				label: 'Metrika',
				clearable: false,
				value: 1,
				options: _dbinfo2['default'].Metric.asArray()
			}
		};
		this.form = new _reactisForms.FormManager(this.schema);
	}

	Page.prototype.render = function render() {
		var metric = this.form.getValues().toJS().metric;

		return _react2['default'].createElement(
			'div',
			{ className: 'tdidocument' },
			_react2['default'].createElement(_reactDocumentTitle2['default'], { title: 'Graf' }),
			_react2['default'].createElement(
				'div',
				{ className: 'panel', style: { paddingBottom: 0, minHeight: 680 } },
				_react2['default'].createElement(
					'div',
					{ style: { padding: 20 } },
					_react2['default'].createElement(
						'div',
						{ style: { position: 'absolute', right: 30, zIndex: 10, width: 150 } },
						_react2['default'].createElement(
							_reactisForms.RxForm,
							{ ref: 'form', form: this.form, id: 'chart.filter' },
							_react2['default'].createElement(_reactisForms.FormField, { name: 'metric' })
						)
					),
					_react2['default'].createElement(_Chart2['default'], { metric: metric })
				)
			)
		);
	};

	var _Page = Page;
	Page = _wrapComponent('_$Page')(Page) || Page;
	Page = _reactRedux.connect(function (state, props) {
		return {
			form: state.forms.get('chart.filter')
		};
	}, function (dispatch) {
		return { actions: _redux.bindActionCreators(actions, dispatch) };
	})(Page) || Page;
	return Page;
})(_componentsComponent2['default']);

exports['default'] = Page;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Chart/Page.js
 ** module id = 965
 ** module chunks = 2
 **/